import { Inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { IBetslipMessages } from '../../../../../base/models/betslip-messages';
import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { BetslipError } from '../../../errors/betslip-error';
import { NoMultiSinglesPreCheckError } from '../../../errors/pre-check/no-multi-singles-pre-check-error';
import { MessageFormatter } from './message-formatter';

@Injectable()
export class NoMultiSinglesPreCheckErrorMessageFormatter extends MessageFormatter<NoMultiSinglesPreCheckError> {
    private messages: IBetslipMessages;
    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService) {
        super();
        this.messages = messageProvider.getMessages();
    }

    format(_error: NoMultiSinglesPreCheckError): Observable<string> {
        return of(this.messages.validation.MultipleSinglesNotAllowed);
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof NoMultiSinglesPreCheckError;
    }
}
